import { setIncompleteProfileModal } from '../../store/workspace/slice';
import { selectUserAttributes } from '../../store/workspace/selectors';
import { setAccessToProtectedRoutes } from '../../store/auth/slice';
import { IncompleteProfileIcon } from '../../assets/icons/common';
import { useDispatch, useSelector } from '../../store/store';
import { selectUserId } from '../../store/auth/selectors';
import { signOutThunk } from '../../store/auth/thunks';
import { useNavigate } from 'react-router-dom';
import Modal from '../../components/Modal';
import styles from './style.module.scss';
import {
    setUserEmail,
    setSignUpStep,
    setPersonalInfo,
    setSignUpUserId,
} from '../../store/signUp/slice';

export default function IncompleteProfile() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = useSelector(selectUserId);
    const userAttributes = useSelector(selectUserAttributes);

    const next = () => {
        if (!userAttributes) return;

        const info = {
            Email: userAttributes.email || '',
            DOB: userAttributes.birthdate || '',
            Address: userAttributes.address || '',
            FirstName: userAttributes.given_name || '',
            LastName: userAttributes.family_name || '',
            Phone_Number: userAttributes.phone_number || '',
            City: userAttributes["custom:city"] || '',
            State: userAttributes["custom:state"] || '',
            Country: userAttributes["custom:country"] || '',
            Zip_Code: userAttributes["custom:zipCode"] || '',
            LinkdIn_Link: userAttributes["custom:linkedinLink"] || '',
            Preferred_Name: userAttributes["custom:preferredName"] || '',
        };

        dispatch(setSignUpStep('personalInfo'));
        dispatch(setAccessToProtectedRoutes(true));
        dispatch(setIncompleteProfileModal(false));
        dispatch(setSignUpUserId(userId || undefined));
        dispatch(setUserEmail(userAttributes?.email || ''));
        dispatch(setPersonalInfo(info));
        navigate('/signup');
    };

    return (
        <Modal
            size='lg'
            actions='both'
            title='Incomplete profile'
            childClassName={styles.wrapper}
            icon={<IncompleteProfileIcon />}
            dismissButton={{
                text: 'Sign out from account',
                type: 'Error',
                onClick: () => dispatch(signOutThunk()),
            }}
            confirmButton={{
                text: 'Start process',
                type: 'Primary',
                onClick: next,
            }}
        >
            <h3 className={styles.text}>For access to your account, please complete the sign up process.</h3>
        </Modal>
    )
}
